import { createElement as rc } from 'react';
import ButtonGl2025 from './Button.gl2025';

function ButtonGl2025Adapter(props) {
    const {
        value, // old prop name
        text, // new prop name,
        icon,
        size = 'sm',
        variant: _variant,
        buttonStyle, // old prop - convert to variant
        destructive: _destructive = false,
        disabled = false,
        color,
        onPress,
        onClick: _onClick,
        ...otherProps
    } = props;

    const onClick = _onClick || onPress;
    // todo gl2025: these can be removed, just for backwards compatibility
    const destructive = _destructive || color === 'error';

    // Priority: explicit variant > buttonStyle conversion > color-based > default
    let variant = _variant;
    if (!variant && buttonStyle) {
        variant = getVariantFromButtonStyle(buttonStyle);
    }
    if (!variant && color === 'gray') {
        variant = 'secondary';
    }
    if (!variant) {
        variant = 'primary';
    }

    return rc(ButtonGl2025, {
        text: text ?? value,
        icon,
        size,
        variant,
        buttonStyle, // pass through for icon-only detection in Button.gl2025.js
        destructive,
        disabled,
        onClick,
        ...otherProps
    });
}

// Map old buttonStyle values to new variant values
function getVariantFromButtonStyle(buttonStyle) {
    if (!buttonStyle) return null;
    const style = buttonStyle.toLowerCase();
    switch (style) {
        case 'primary':
            return 'primary';
        case 'secondary':
            return 'secondary';
        case 'tertiary':
        case 'inline':
        case 'round':
        case 'iconaction':
        case 'bigiconaction':
        case 'circleadd':
        case 'unstyled':
            return 'tertiary';
        case 'link':
            return 'link';
        default:
            return null;
    }
}

export default ButtonGl2025Adapter;
